<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a job type drop down
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="row">
        <div class="form-group col-6">
            <label>Industry</label>
            <select class="form-control form-control" :name="ind_input" :value="industry_data" v-on:input="update_ind($event)" @change="change">
                <option value="0">Please select an industry</option>
                <option v-for="ind in industries_actual" :key="ind.id" :value="ind.id">{{ind.name}}</option>
            </select>
        </div>      
        <div class="form-group col-6"><label>Job Type</label>
            <select class="form-control form-control" :name="job_input" :key="job_data" :value="job_data" v-on:input="update_job($event)" @change="change">
                <option value="0">Please select a job type</option>
                <option v-for="ind in job_list" :key="ind.id" :value="ind.id">{{ind.name}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            //the name of the input
            start: {
                type: String,
                default: ''
            },
            //the industries
            industries: {
                type: String,
                default: '[]'
            },
            //the industries
            industriesArray: {
                type: Array,
            },
            //the job type
            job_type: {
                default: 0
            },
            //the width
            width: {
                default: ''
            },
            //if true, sends the industry as well as the job type in the return
            send_industry: {
                type: Boolean,
                default: false
            },
            //the defalt value
            value: {
                default: ''
            },
        },
        mounted(){
            this.setJob(this.job_type)
            if(this.value !== null && this.isNumber(this.value)){
                this.setJob(this.value)
            } else if(this.value !== null && this.value.length > 0){
                var val = JSON.parse(this.value.replace(/\|/g, ','));
                this.industry_data = val.industry;
                this.job_data = val.job;
                this.$editableFormsIndustry = this.industry_data;
                this.$editableFormsJobType = this.job_data;
            }
        },
        data() {
            return {
                industry_data: 0,
                job_data: -1,
                //the name of the input
                start_data: this.start
            };
        },
        computed: {
            /**
             * returns current list of jobs
             * 
             * @return Array the list
             */
            industries_actual: function () {
                if(this.industries == '[job-types]'){
                    return [];
                } else if(this.industriesArray !== undefined){
                    return this.industriesArray;
                } else {
                    return JSON.parse(this.industries);
                }
            },
            /**
             * returns current list of jobs
             * 
             * @return Array the list
             */
            job_list: function () {
                for(var i=0; i<this.industries_actual.length; i++){
                    if(this.industries_actual[i].id == this.industry_data){
                        return this.industries_actual[i].job_types;
                    }
                }
                return [];
            },
            /**
             * returns the name of the industry input
             * 
             * @return String the name
             */
            ind_input: function () {return this.start_data + 'industry'},
            /**
             * returns the name of the job input
             * 
             * @return String the name
             */
            job_input: function () {return this.start_data + 'industry_job'},
        },
        methods: {
            isNumber: function (n) { return /^-?[\d]+\.?[\d]+(?:e-?\d+)?$/.test(n); } ,
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_ind: function (value) {
                //if(this.industry_data != 0){
                    this.job_data = 0;
                //}
                this.industry_data = value.target.value;
                if(this.send_industry){
                    //because it is used with the filters, replace commas with | so that it doesn't get confused when exploding
                     this.$emit('input', JSON.stringify({industry: this.industry_data,job:this.job_data}).replace(/,/g, '|'));
                } else {
                    this.$emit('input', this.job_data);
                }
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_job: function (value) {
                this.job_data = value.target.value;
                if(this.send_industry){
                    //because it is used with the filters, replace commas with | so that it doesn't get confused when exploding
                     this.$emit('input', JSON.stringify({industry: this.industry_data,job:this.job_data}).replace(/,/g, '|'));
                } else {
                    this.$emit('input', this.job_data);
                }
                this.change();
            },
            /**
             * gets the industry from the job type
             * @param number job the job type id
             * @returns the appropriate industry
             */
            get_industry: function (job) {
                for(var i=0; i<this.industries_actual.length; i++){
                    for(var j=0; j<this.industries_actual[i].job_types.length; j++){
                        if(this.industries_actual[i].job_types[j].id == job){
                            return this.industries_actual[i];
                        }
                    }
                }
                return {id: 0, name: ''}
            },
            setJob: function(job){
                this.industry_data = this.get_industry(job).id;
                if(this.industry_data == 0 && this.industries_actual.length > 0){
                    //this.industry_data = this.industries_actual[0].id;
                    this.job_data = 0;
                } else {
                    this.job_data = job;
                }
                this.$editableFormsIndustry = this.industry_data;
                this.$editableFormsJobType = this.job_data;
            },
            change: function(){
                this.$emit('change');
            }
        },
        watch: {
            /**
             * Handle changes to job type
             */
            job_data: function() {
                this.$editableFormsJobType = this.job_data;
            },
            industry_data: function() {
                this.$editableFormsIndustry = this.industry_data;
            },
        }
    }
</script>
